import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { ExtractStringArrayKeys } from '../../../../../../react-commons/types/extractKeysOfType';
import { Form_PropertyFieldArrayReference } from '../reference-text-fields/Form_PropertyFieldArrayReference';
import { useProjectUserGroupActions } from '../../../../resource/resources/persistables/user/projectUserGroupResource';

export const Form_ProjectUserGroupFieldArray = <T extends object>({
                                                                      parentId,
                                                                      name,
                                                                      form,
                                                                      readOnly,
                                                                      disabled,
                                                                      label,
                                                                  }: {
    parentId: string;
    form: UseFormReturn<T>;
    readOnly: boolean;
    disabled?: boolean;
    name: ExtractStringArrayKeys<T, false>;
    label: string;
}) => {
    const projectUserGroupActions = useProjectUserGroupActions()
    const projectUserGroupQuery = projectUserGroupActions.useGetAllResources(parentId);

    return (
        <Form_PropertyFieldArrayReference
            control={form.control}
            name={name}
            query={projectUserGroupQuery}
            readOnly={readOnly}
            label={label}
            disabled={disabled}
            idSelector={'id'}
            labelAccessor={'name'}
            propertyValidation={undefined}
            propertyDetails={undefined}
            uniqueSelection={true}
            initialOpen={true}
        />
    );
};
